const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

/**
 * 文字列が UUID 形式かどうかを判定する。
 * RFC 4122 の variant bits を持つ UUID v1〜v8 に対応する。
 */
export function isUuid(id: string | undefined | null): boolean {
  if (!id || typeof id !== 'string') {
    return false
  }

  return UUID_PATTERN.test(id)
}
